/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Lots_Col_PurchaseInputs */

const vi_pl_lots_col_purchase = /** @type {(inputs: Pl_Lots_Col_PurchaseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn mua`)
};

/**

* @param {Pl_Lots_Col_PurchaseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_lots_col_purchase = /** @type {((inputs?: Pl_Lots_Col_PurchaseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Lots_Col_PurchaseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_lots_col_purchase(inputs)
});